export interface ProductCategory {
  code: string;
  parentCode: string | null;
  sortOrder: number;
  labelKey: string;
  children: ProductCategory[];
}

export const productCategories: ProductCategory[] = [
  {
    code: '01',
    parentCode: null,
    sortOrder: 1,
    labelKey: 'products.categories.glass',
    children: [
      { code: '0101', parentCode: '01', sortOrder: 1, labelKey: 'products.categories.glass.toner', children: [] },
      { code: '0102', parentCode: '01', sortOrder: 2, labelKey: 'products.categories.glass.creamJar', children: [] },
      { code: '0103', parentCode: '01', sortOrder: 3, labelKey: 'products.categories.glass.ampoule', children: [] },
    ],
  },
  {
    code: '02',
    parentCode: null,
    sortOrder: 2,
    labelKey: 'products.categories.petg',
    children: [
      { code: '0201', parentCode: '02', sortOrder: 1, labelKey: 'products.categories.petg.serum', children: [] },
      { code: '0202', parentCode: '02', sortOrder: 2, labelKey: 'products.categories.petg.toner', children: [] },
      { code: '0203', parentCode: '02', sortOrder: 3, labelKey: 'products.categories.petg.creamJar', children: [] },
      { code: '0204', parentCode: '02', sortOrder: 4, labelKey: 'products.categories.petg.shampoo', children: [] },
    ],
  },
  {
    code: '03',
    parentCode: null,
    sortOrder: 3,
    labelKey: 'products.categories.airless',
    children: [
      { code: '0301', parentCode: '03', sortOrder: 1, labelKey: 'products.categories.airless.serum', children: [] },
      { code: '0302', parentCode: '03', sortOrder: 2, labelKey: 'products.categories.airless.toner', children: [] },
      { code: '0303', parentCode: '03', sortOrder: 3, labelKey: 'products.categories.airless.creamJar', children: [] },
    ],
  },
  {
    code: '04',
    parentCode: null,
    sortOrder: 4,
    labelKey: 'products.categories.specialty',
    children: [
      { code: '0401', parentCode: '04', sortOrder: 1, labelKey: 'products.categories.specialty.syringe', children: [] },
      { code: '0402', parentCode: '04', sortOrder: 2, labelKey: 'products.categories.specialty.powder', children: [] },
      { code: '0403', parentCode: '04', sortOrder: 3, labelKey: 'products.categories.specialty.cleansingPad', children: [] },
      { code: '0404', parentCode: '04', sortOrder: 4, labelKey: 'products.categories.specialty.sample', children: [] },
      { code: '0405', parentCode: '04', sortOrder: 5, labelKey: 'products.categories.specialty.accessories', children: [] },
    ],
  },
  {
    code: '05',
    parentCode: null,
    sortOrder: 5,
    labelKey: 'products.categories.tubes',
    children: [
      { code: '0501', parentCode: '05', sortOrder: 1, labelKey: 'products.categories.tubes.eyeCream', children: [] },
      { code: '0502', parentCode: '05', sortOrder: 2, labelKey: 'products.categories.tubes.flipScrew', children: [] },
      { code: '0503', parentCode: '05', sortOrder: 3, labelKey: 'products.categories.tubes.brushSponge', children: [] },
      { code: '0504', parentCode: '05', sortOrder: 4, labelKey: 'products.categories.tubes.rollerComb', children: [] },
      { code: '0505', parentCode: '05', sortOrder: 5, labelKey: 'products.categories.tubes.airlessPump', children: [] },
      { code: '0506', parentCode: '05', sortOrder: 6, labelKey: 'products.categories.tubes.makeup', children: [] },
      { code: '0507', parentCode: '05', sortOrder: 7, labelKey: 'products.categories.tubes.toothpaste', children: [] },
      { code: '0508', parentCode: '05', sortOrder: 8, labelKey: 'products.categories.tubes.aluminum', children: [] },
    ],
  },
  {
    code: '06',
    parentCode: null,
    sortOrder: 6,
    labelKey: 'products.categories.pumpsDroppers',
    children: [
      { code: '0601', parentCode: '06', sortOrder: 1, labelKey: 'products.categories.pumpsDroppers.mist', children: [] },
      { code: '0602', parentCode: '06', sortOrder: 2, labelKey: 'products.categories.pumpsDroppers.dropper', children: [] },
      { code: '0603', parentCode: '06', sortOrder: 3, labelKey: 'products.categories.pumpsDroppers.oilPump', children: [] },
      { code: '0604', parentCode: '06', sortOrder: 4, labelKey: 'products.categories.pumpsDroppers.serumPump', children: [] },
      { code: '0605', parentCode: '06', sortOrder: 5, labelKey: 'products.categories.pumpsDroppers.shampooPump', children: [] },
      { code: '0606', parentCode: '06', sortOrder: 6, labelKey: 'products.categories.pumpsDroppers.trigger', children: [] },
      { code: '0607', parentCode: '06', sortOrder: 7, labelKey: 'products.categories.pumpsDroppers.caps', children: [] },
    ],
  },
  {
    code: '07',
    parentCode: null,
    sortOrder: 7,
    labelKey: 'products.categories.sheetPouch',
    children: [
      { code: '0701', parentCode: '07', sortOrder: 1, labelKey: 'products.categories.sheetPouch.mask', children: [] },
      { code: '0702', parentCode: '07', sortOrder: 2, labelKey: 'products.categories.sheetPouch.cleansing', children: [] },
      { code: '0703', parentCode: '07', sortOrder: 3, labelKey: 'products.categories.sheetPouch.specialty', children: [] },
      { code: '0704', parentCode: '07', sortOrder: 4, labelKey: 'products.categories.sheetPouch.pouch', children: [] },
    ],
  },
  {
    code: '08',
    parentCode: null,
    sortOrder: 8,
    labelKey: 'products.categories.boxes',
    children: [
      { code: '0801', parentCode: '08', sortOrder: 1, labelKey: 'products.categories.boxes.folding', children: [] },
      { code: '0802', parentCode: '08', sortOrder: 2, labelKey: 'products.categories.boxes.giftSet', children: [] },
      { code: '0803', parentCode: '08', sortOrder: 3, labelKey: 'products.categories.boxes.round', children: [] },
      { code: '0804', parentCode: '08', sortOrder: 4, labelKey: 'products.categories.boxes.outer', children: [] },
    ],
  },
  {
    code: '09',
    parentCode: null,
    sortOrder: 9,
    labelKey: 'products.categories.makeup',
    children: [
      { code: '0901', parentCode: '09', sortOrder: 1, labelKey: 'products.categories.makeup.cushion', children: [] },
      { code: '0902', parentCode: '09', sortOrder: 2, labelKey: 'products.categories.makeup.lip', children: [] },
      { code: '0903', parentCode: '09', sortOrder: 3, labelKey: 'products.categories.makeup.puff', children: [] },
      { code: '0904', parentCode: '09', sortOrder: 4, labelKey: 'products.categories.makeup.other', children: [] },
    ],
  },
  {
    code: '10',
    parentCode: null,
    sortOrder: 10,
    labelKey: 'products.categories.misc',
    children: [
      { code: '1001', parentCode: '10', sortOrder: 1, labelKey: 'products.categories.misc.labels', children: [] },
      { code: '1002', parentCode: '10', sortOrder: 2, labelKey: 'products.categories.misc.pvcFilm', children: [] },
    ],
  },
];